<header id="nav-bar-header">
  <div class="container">
    <nav class="navbar navbar-expand-lg">
      <a class="navbar-brand d-flex align-items-center" href="#">
        <img class="navbar-icon"
          src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/adoretheballoon/adoretheballoon-logo-v2-main.png"
          alt="Adore The Balloon Logo" />
      </a>

      @if (showMenu()) {
      <div class="d-lg-flex d-none align-items-center gap-4 desktop-nav-links">
        <!-- <a class="desktop-nav-link" [href]="getFeatureLink" target="_blank">Features</a> -->
        <a class="desktop-nav-link" href="#how-it-works">How it Works</a>
        <a class="desktop-nav-link" href="#Download">Download</a>
        <a class="desktop-nav-link" routerLink="/pricing">Pricing</a>
        <a class="desktop-nav-link" [href]="getContactUsLink" target="_blank">Contact</a>
      </div>
      }

      <button class="navbar-toggler" type="button" (click)="toggleMenu()">
        <div class="hamburger" [class.active]="isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <div class="d-lg-flex d-none gap-4 align-items-center">
        <a routerLink="/auth/login" class="base-btn gradient-btn">
          {{ sessionData?.isAuthenticated ? "Go To Login" : "Login" }}
        </a>
        @if (sessionData?.isAuthenticated) {
        <div class="d-none d-lg-block" style="cursor: pointer">
          <a (click)="logout()">Logout</a>
        </div>
        }
      </div>
    </nav>

    <div class="mobile-menu d-lg-none" [class.active]="isMenuOpen">
      <ul class="mobile-nav-list">

        <li class="nav-item">
          <a class="nav-link" [href]="getFeatureLink" target="_blank">Feature Request</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [href]="getBugRepoLink" target="_blank">Report Bug</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#how-it-works" (click)="closeMenu()">How it Works</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#Download" (click)="closeMenu()">Download</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/pricing" (click)="closeMenu()">Pricing</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [href]="getContactUsLink" target="_blank">Contact</a>
        </li>

        <!-- Mobile Auth Section -->
        <div class="mobile-auth-section">
          <li class="d-lg-none align-self-start">
            <a routerLink="/auth/login" class="mobile-nav-link mobile-cta">
              {{ sessionData?.isAuthenticated ? "Go To Login" : "Login" }}
            </a>
          </li>

          @if (!sessionData?.isAuthenticated) {
          <li class="d-lg-none align-self-start">
            <a [href]="pwaUrl" class="mobile-nav-link mobile-cta">
              Sign Up
            </a>
          </li>
          }

          @if (sessionData?.isAuthenticated) {
          <li class="d-lg-none align-self-start">
            <a (click)="logout()" class="mobile-nav-link mobile-cta-last">Logout</a>
          </li>
          }
        </div>

      </ul>
    </div>
  </div>
</header>